import React from 'react';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import Text from 'components/ui/Typography/Text';

const VersionHistoryInfo = ({ version: v, currentVersion, textVariant }) => {
  return (
    <>
      <Text variant={textVariant}>
        {`${v.version}. ${moment(v.published_at).format(
          DateFormat.LONG_AT_TIME,
        )} ${t('versions.by')} ${v.publisher} `}
      </Text>
      {v.id === currentVersion && (
        <Text variant={textVariant}>
          {`${t('versions.parentheses_wrapped_current')} `}
        </Text>
      )}
    </>
  );
};

export default VersionHistoryInfo;
